import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import retrexlogo from 'assets/icons/retrexlogo.png';
import successgif from 'assets/gifs/successgif.gif';
import { getApiCall, postApiCall } from 'api/apiService';
import { VENDOR_GETQUESTION, VENDOR_SAVEQUESTION } from 'constant/app.config';
import {
  Bedrooms,
  CancelBtn,
  CancelBtnMobile,
  Floorplan,
  Garden,
  Location,
  Locationwhite,
  NaturalLightIcon,
  OverAllIcon,
  SelectIcon,
  SuccessBtn,
  SuccessBtnMobile,
  OutdoorSpaceIcon,
  DesignStyleIcon,
  ViewsIcon,
} from './Icons';
import {
  Calendar,
  ChatLoading,
  PriceBracketChat,
  PropertyWorthChat,
  TextBoxChat,
} from './ChatComponent';
import Loading from 'assets/images/loading.png';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { RayWhite } from 'modules/private/BuyerDashboard/BuyerChat';
import AgencyBadge from 'component/Common/AgencyBadge';

// chat question component
const ChatQuestion = ({ question }) => {
  const only450screen = useMediaQuery((theme) => theme.breakpoints.down(450));

  return (
    <Stack
      direction={'row'}
      justifyContent={'center'}
      alignItems={'flex-end'}
      gap={'20px'}
      minWidth="45%"
      maxWidth="90%"
    >
      <Box
        sx={{
          background: 'rgba(0, 101, 252, 1)',
          width: '90%',
          borderRadius: '50px',
          zIndex: '100',
        }}
      >
        <Typography
          component={'p'}
          sx={{
            color: 'white',
            fontSize: { xs: '13px', sm: '15px', md: '20px' },
            fontFamily: 'Poppins',
            fontWeight: '400',
            textAlign: 'left',
            padding: '20px',
          }}
        >
          {question}
        </Typography>
      </Box>
      <Box
        sx={{
          height: only450screen ? '40px' : '56px',
          width: only450screen ? '40px' : '56px',
          background: 'white',
          borderRadius: '50%',
          bottom: '-30px',
          right: '-30px',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 2px 6px rgba(0,0,0,0.12)', // 👈 light shadow
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins',
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
          }}
        >
          <img
            alt="Logo"
            src={Loading}
            style={{ height: '40px', width: '40px' }}
          />
        </Typography>
      </Box>
    </Stack>
  );
};

const ChatOptions = ({ question, handleInputChange }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  const options1 = [
    { label: 'Financial reason', icon: Bedrooms },
    { label: 'Relocation', icon: Floorplan },
    { label: 'Job changes', icon: OverAllIcon },
    { label: 'Other reason', icon: Garden },
  ];
  const options2 = [
    { label: 'Auction', icon: Bedrooms },
    { label: 'Pre auction', icon: Floorplan },
  ];

  const options3 = [
    { label: 'Nature Light', icon: NaturalLightIcon },
    { label: 'Location', icon: Location },
    { label: 'Floorplan/Layout', icon: Floorplan },
    { label: 'Outdoor Space', icon: OutdoorSpaceIcon },
    { label: 'Design/Style', icon: DesignStyleIcon },
    { label: 'Views', icon: ViewsIcon },
    // { label: 'location', icon: Location },
    // { label: 'atmosphere', icon: Floorplan },
    // { label: 'building age', icon: OverAllIcon },
    // { label: 'other feature', icon: Location },
  ];

  const options4 = [
    { label: 'Nature Light', icon: NaturalLightIcon },
    { label: 'Location', icon: Location },
    { label: 'Floorplan/Layout', icon: Floorplan },
    { label: 'Outdoor Space', icon: OutdoorSpaceIcon },
    { label: 'Design/Style', icon: DesignStyleIcon },
    { label: 'Views', icon: ViewsIcon },
    // { label: 'price range', icon: Floorplan },
    // { label: 'location', icon: Location },
    // { label: 'landsize', icon: Garden },
    // { label: 'other', icon: NaturalLightIcon },
  ];

  useEffect(() => {
    setOptions(
      question?.questionCode == 'VQ001'
        ? options1
        : question?.questionCode == 'VQ007'
        ? options2
        : question?.questionCode == 'VQ008'
        ? options3
        : question?.questionCode == 'VQ009'
        ? options4
        : []
    );
  }, [question]);

  return (
    <Box
      sx={{
        width: { md: '100%', lg: '500px' },
      }}
    >
      {question?.questionCode === 'VQ008' ||
      question?.questionCode === 'VQ009' ? (
        <></>
      ) : (
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: matchessm ? '12px' : '18px',
            fontWeight: '300',
            textAlign: 'center',
            display: 'block',
            p: '20px 0px',
          }}
        >
          Please select
        </Typography>
      )}
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-around',
        }}
        md={12}
      >
        {options?.map((item, index) => {
          const IconComponent = item?.icon;
          return (
            <Grid
              key={index}
              item
              md={4}
              sm={4}
              xs={4}
              sx={{ textAlign: 'center' }}
            >
              <IconButton
                disableTouchRipple
                disableFocusRipple
                disableRipple
                onClick={() => {
                  if (
                    question?.questionCode === 'VQ008' ||
                    question?.questionCode === 'VQ009'
                  ) {
                    handleInputChange(item?.label, true);
                  } else {
                    handleInputChange(item?.label);
                  }
                }}
                sx={{ position: 'relative' }}
              >
                <Stack
                  direction={'column'}
                  alignItems={'center'}
                  spacing={1}
                  justifyContent={'space-between'}
                  sx={{
                    width: matchessm ? '100%' : '150px',
                    height: !matchessm && '95px',
                  }}
                >
                  <IconComponent
                    value={question?.questionAnswer?.includes(item?.label)}
                  />
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: matchessm ? '12px' : '15px',
                      fontWeight: '300',
                      textAlign: 'center',
                    }}
                  >
                    {item.label}
                  </Typography>
                </Stack>
                {question?.questionAnswer?.includes(item?.label) && (
                  <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                    <SelectIcon />
                  </Box>
                )}
              </IconButton>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const VendorChat = () => {
  const history = useHistory();
  const location = useLocation();
  const previousRoute = location.state?.from;
  // final thanks Screen trigger
  const [finalTrigger, setFinalTrigger] = useState(false);
  const [questionData, setQuestionData] = useState([{ other: '' }]);
  const [address, setAddress] = useState('');
  const [agentAgencyName, setAgentAgencyName] = useState('');
  const [propertyId, setPropertyId] = useState('');
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState(false);
  const [priceRange, setPriceRange] = useState('');

  // chat loading
  const [loading, setLoading] = React.useState(false);

  // current question validations
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('questions'))?.questions ?? {};
    const address =
      JSON.parse(localStorage.getItem('questions'))?.address ?? {};
    const propertyId =
      JSON.parse(localStorage.getItem('questions'))?.propertyId ?? {};
    const priceRange =
      JSON.parse(localStorage.getItem('questions'))?.priceRange ?? null;
    const agentAgencyName =
      JSON.parse(localStorage.getItem('questions'))?.agentAgencyName ?? '';
    if (data && data?.length) {
      setCurrentQuestionIndex(0);
      setQuestionData(data);
      setAddress(address);
      setPropertyId(propertyId);
      setPriceRange(priceRange);
      setAgentAgencyName(agentAgencyName);
    }
  }, []);

  const handleChatReview = (vendorQuestionsData, nextStep) => {
    if (currentQuestionIndex != questionData?.length - 1) {
      setLoading(true);
    }
    postApiCall(VENDOR_SAVEQUESTION, vendorQuestionsData)
      .then((res) => {
        if (currentQuestionIndex == questionData?.length - 1) {
          setCurrentQuestionIndex(null);
          setFinalTrigger(true);
          setTimeout(() => {
            history.goBack();
          }, 2000);
        } else {
          setCurrentQuestionIndex(nextStep);
          setLoading(false);
        }
        getApiCall(`${VENDOR_GETQUESTION}/${propertyId}`).then((res) => {
          const result = res?.data?.vendorQuestions.filter(
            (value) => value.questionAnswer == ''
          );
          const questionsData = {
            priceRange: res?.data?.priceRange,
            propertyId: propertyId,
            address: address,
            agentAgencyName: res?.data?.agentAgencyName,
            questions: result,
          };

          localStorage.setItem('questions', JSON.stringify(questionsData));
        });
      })

      .finally(() => {});
  };

  const handleNext = () => {
    if (currentQuestionIndex <= questionData?.length - 1) {
      const isOtherRequired =
        questionData[currentQuestionIndex]?.questionAnswer === 'Other reason' ||
        questionData[currentQuestionIndex]?.questionAnswer ===
          'other feature' ||
        questionData[currentQuestionIndex]?.questionAnswer === 'other';

      if (
        isOtherRequired &&
        !questionData[currentQuestionIndex]?.other?.trim()
      ) {
        setError(true);
        return;
      } else {
        setError(false);
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'VQ006' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Yes' &&
        !questionData[currentQuestionIndex]?.date
      ) {
        setErrors(true);
        return;
      } else {
        setErrors(false);
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'VQ001' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'Other reason'
      ) {
        const textQuestionPayload = {
          vendorQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer: questionData[currentQuestionIndex]?.other,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(textQuestionPayload, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'VQ002' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'No'
      ) {
        const questionDataVQ002 = {
          vendorQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
            {
              questionId: questionData[currentQuestionIndex + 1]?.questionId,
              questionCode: 'VQ003',
              questionValue:
                questionData[currentQuestionIndex + 1]?.questionValue,
              questionAnswer: 'No',
              questionIsSkiped: questionData[currentQuestionIndex + 1]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 2;
        handleChatReview(questionDataVQ002, nextStep);
        return;
      }

      if (questionData[currentQuestionIndex]?.questionCode === 'VQ006') {
        const questionDataPayload = {
          vendorQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer === 'Yes'
                  ? questionData[currentQuestionIndex]?.date
                  : questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(questionDataPayload, nextStep);
        return;
      }

      if (
        questionData[currentQuestionIndex]?.questionCode === 'VQ008' &&
        questionData[currentQuestionIndex]?.questionAnswer === 'other feature'
      ) {
        const textQuestionPayload = {
          vendorQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer: questionData[currentQuestionIndex]?.other,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
          ],
        };
        const nextStep = currentQuestionIndex + 1;
        handleChatReview(textQuestionPayload, nextStep);
        return;
      }

      if (questionData[currentQuestionIndex]?.questionCode === 'VQ009') {
        const textQuestionPayload = {
          vendorQuestionData: [
            {
              questionId: questionData[currentQuestionIndex]?.questionId,
              questionCode: questionData[currentQuestionIndex]?.questionCode,
              questionValue: questionData[currentQuestionIndex]?.questionValue,
              questionAnswer:
                questionData[currentQuestionIndex]?.questionAnswer === 'other'
                  ? questionData[currentQuestionIndex]?.other
                  : questionData[currentQuestionIndex]?.questionAnswer,
              questionIsSkiped: questionData[currentQuestionIndex]
                ?.questionAnswer
                ? 0
                : 1,
              propertyId: propertyId,
            },
          ],
        };

        const nextStep = currentQuestionIndex + 1;
        handleChatReview(textQuestionPayload, nextStep);
        return;
      }

      const vendorQuestionsData = {
        vendorQuestionData: [
          {
            questionId: questionData[currentQuestionIndex]?.questionId,
            questionCode: questionData[currentQuestionIndex]?.questionCode,
            questionValue: questionData[currentQuestionIndex]?.questionValue,
            questionAnswer: questionData[currentQuestionIndex]?.questionAnswer,
            questionIsSkiped: questionData[currentQuestionIndex]?.questionAnswer
              ? 0
              : 1,
            propertyId: propertyId,
          },
        ],
      };

      const nextStep = currentQuestionIndex + 1;
      handleChatReview(vendorQuestionsData, nextStep);
    } else {
      setCurrentQuestionIndex(null);
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setFinalTrigger(true);
      }, 2000);
    }
  };

  const handleMultiSelectInputChange = (value) => {
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      let currentAnswer =
        updatedQuestions[currentQuestionIndex].questionAnswer || [];
      if (!Array.isArray(currentAnswer)) {
        currentAnswer = [currentAnswer].filter(Boolean);
      }

      if (currentAnswer.includes(value)) {
        currentAnswer = currentAnswer.filter((item) => item !== value);
      } else {
        currentAnswer = [...currentAnswer, value];
      }

      updatedQuestions[currentQuestionIndex].questionAnswer = currentAnswer;
    }
    setQuestionData(updatedQuestions);
  };

  const handleInputChange = (value, isMulti = false) => {
    if (isMulti) {
      handleMultiSelectInputChange(value);
      return;
    }
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      updatedQuestions[currentQuestionIndex].questionAnswer = value;
    }
    setQuestionData(updatedQuestions);
  };

  const handleDateChange = (date) => {
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      updatedQuestions[currentQuestionIndex].date = date;
    }
    setQuestionData(updatedQuestions);
  };

  const handleTextBoxChange = (val) => {
    const updatedQuestions = [...questionData];
    if (updatedQuestions[currentQuestionIndex]) {
      updatedQuestions[currentQuestionIndex].other = val;
    }
    setQuestionData(updatedQuestions);
    setError(false);
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          backgroundColor: '#fff',
        }}
      >
        {' '}
        <DialogTitle sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              mt: matchessm ? '0px' : '20px',
            }}
          >
            <Locationwhite />
            <Typography
              style={{
                color: 'rgba(30, 30, 30, 1)',
                fontFamily: 'Poppins',
                fontWeight: '600',
              }}
              sx={{
                fontSize: {
                  xs: '14px',
                  sm: '20px',
                  md: '24px',
                  lg: '26px',
                  xl: '30px',
                },
              }}
            >
              {address ?? ''}
            </Typography>
          </Box>
        </DialogTitle>
        {agentAgencyName && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: matchessm ? '0px' : '20px',
            }}
          >
            <AgencyBadge name={agentAgencyName} variant="survey" />
          </Box>
        )}
        <DialogContent
          sx={{
            mt: matchessm ? '5px' : '50px',
            padding: '0px',
            height: matchessm ? '70%' : '60%',
          }}
        >
          {' '}
          <Stack
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={matchessm ? '0px' : '25px'}
            marginTop={'20px'}
          >
            <>
              {!loading &&
                (questionData[currentQuestionIndex]?.questionCode === 'VQ001' ||
                  questionData[currentQuestionIndex]?.questionCode == 'VQ007' ||
                  questionData[currentQuestionIndex]?.questionCode == 'VQ008' ||
                  questionData[currentQuestionIndex]?.questionCode ==
                    'VQ009') && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <ChatOptions
                      handleInputChange={handleInputChange}
                      question={questionData[currentQuestionIndex]}
                    />
                    {((questionData[currentQuestionIndex]?.questionCode ===
                      'VQ001' &&
                      questionData[currentQuestionIndex]?.questionAnswer ===
                        'Other reason') ||
                      (questionData[currentQuestionIndex]?.questionCode ===
                        'VQ008' &&
                        questionData[currentQuestionIndex]?.questionAnswer ===
                          'other feature') ||
                      (questionData[currentQuestionIndex]?.questionCode ===
                        'VQ009' &&
                        questionData[currentQuestionIndex]?.questionAnswer ===
                          'other')) && (
                      <Stack
                        direction={{ xs: 'column', sm: 'row', md: 'row' }}
                        width={{ xs: '60%', sm: '30%', md: '30%' }}
                      >
                        <TextBoxChat
                          handleInputChange={handleTextBoxChange}
                          error={error}
                          setError={setError}
                          value={questionData[currentQuestionIndex]?.other}
                        />
                      </Stack>
                    )}
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={handleNext}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        {currentQuestionIndex == questionData?.length - 1
                          ? 'Submit'
                          : 'Next'}
                      </Button>
                    </Stack>
                  </>
                )}
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'VQ002' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: '6%',
                        flexDirection: 'row',
                        width: matchessm ? '80%' : '30%',
                      }}
                    >
                      <IconButton
                        disableTouchRipple
                        disableFocusRipple
                        disableRipple
                        onClick={() => {
                          handleInputChange('Yes');
                          handleNext();
                        }}
                      >
                        {onlySmallScreen ? (
                          <SuccessBtnMobile />
                        ) : (
                          <SuccessBtn />
                        )}
                      </IconButton>
                      <IconButton
                        disableTouchRipple
                        disableFocusRipple
                        disableRipple
                        onClick={() => {
                          handleInputChange('No');
                          handleNext();
                        }}
                      >
                        {onlySmallScreen ? <CancelBtnMobile /> : <CancelBtn />}
                      </IconButton>
                      <Box
                        sx={{
                          display: 'flex',
                          width: matchessm ? '80%' : '30%',
                          position: 'absolute',
                          flexDirection: 'row',
                          bottom: '20%',
                          justifyContent: 'right',
                        }}
                      >
                        {currentQuestionIndex != 0 && (
                          <IconButton
                            sx={{ fontSize: '16px' }}
                            onClick={() => {
                              setCurrentQuestionIndex(currentQuestionIndex - 1);
                            }}
                          >
                            Back
                          </IconButton>
                        )}
                      </Box>
                    </Box>
                  </>
                )}
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'VQ006' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />

                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: '6%',
                        flexDirection: 'row',
                        width: matchessm ? '80%' : '30%',
                      }}
                    >
                      <IconButton
                        disableTouchRipple
                        disableFocusRipple
                        disableRipple
                        onClick={() => {
                          handleInputChange('Yes');
                        }}
                      >
                        {onlySmallScreen ? (
                          <SuccessBtnMobile />
                        ) : (
                          <SuccessBtn />
                        )}
                      </IconButton>
                      <IconButton
                        disableTouchRipple
                        disableFocusRipple
                        disableRipple
                        onClick={() => {
                          handleInputChange('No');
                          handleNext();
                        }}
                      >
                        {onlySmallScreen ? <CancelBtnMobile /> : <CancelBtn />}
                      </IconButton>
                      <Box
                        sx={{
                          display: 'flex',
                          width: matchessm ? '80%' : '30%',
                          position: 'absolute',
                          flexDirection: 'row',
                          bottom: '20%',
                          justifyContent: 'right',
                        }}
                      >
                        {questionData[currentQuestionIndex]?.questionAnswer !=
                          'Yes' &&
                          currentQuestionIndex != 0 && (
                            <IconButton
                              sx={{ fontSize: '16px' }}
                              onClick={() => {
                                setCurrentQuestionIndex(
                                  currentQuestionIndex - 1
                                );
                              }}
                            >
                              Back
                            </IconButton>
                          )}
                      </Box>
                    </Box>

                    {questionData[currentQuestionIndex]?.questionAnswer ===
                      'Yes' && (
                      <>
                        <Stack
                          direction={'row'}
                          sx={{ minWidth: '30%', maxWidth: '60%' }}
                        >
                          <Calendar
                            onDateSelect={handleDateChange}
                            errors={errors}
                            setErrors={setErrors}
                            value={questionData[currentQuestionIndex]?.date}
                            disablefuture={false}
                            disablepast={true}
                          />
                        </Stack>
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          justifyContent={'right'}
                          width={{ xs: '90%', sm: '45%', md: '45%' }}
                          position={'absolute'}
                          bottom={'20%'}
                        >
                          {currentQuestionIndex != 0 && (
                            <IconButton
                              sx={{ fontSize: '16px', marginRight: '5px' }}
                              onClick={() => {
                                setCurrentQuestionIndex(
                                  currentQuestionIndex - 1
                                );
                              }}
                            >
                              Back
                            </IconButton>
                          )}
                          <Button
                            variant="contained"
                            disableElevation
                            disableFocusRipple
                            disableRipple
                            disableTouchRipple
                            disabled={
                              !(
                                questionData[currentQuestionIndex]
                                  ?.questionAnswer !== null &&
                                questionData[currentQuestionIndex]
                                  ?.questionAnswer !== ''
                              )
                            }
                            onClick={handleNext}
                            sx={{
                              color: 'white',
                              background: 'rgba(76, 164, 214, 1) !important',
                              borderRadius: '20px',
                              width: { xs: 80, sm: 144, md: 144 },
                              textTransform: 'capitalize',
                              fontWeight: 'bold',
                            }}
                            color="primary"
                          >
                            Next
                          </Button>
                        </Stack>
                      </>
                    )}
                  </>
                )}

              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'VQ003' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      height={200}
                      alignItems={'center'}
                      width={{ xs: '90%', sm: '30%', md: '30%' }}
                    >
                      <TextBoxChat
                        handleInputChange={handleInputChange}
                        error={error}
                        setError={setError}
                        value={
                          questionData[currentQuestionIndex]?.questionAnswer
                        }
                      />
                    </Stack>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={() => handleNext()}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        Next
                      </Button>
                    </Stack>
                  </>
                )}
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'VQ004' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      height={200}
                      alignItems={'center'}
                      width={{ xs: '90%', sm: '45%', md: '40%' }}
                    >
                      <PriceBracketChat
                        handleInputChange={handleInputChange}
                        value={
                          questionData[currentQuestionIndex]?.questionAnswer !=
                          ''
                            ? questionData[currentQuestionIndex]?.questionAnswer
                            : priceRange
                        }
                      />
                    </Stack>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 2);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={handleNext}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        Next
                      </Button>
                    </Stack>
                  </>
                )}
              {!loading &&
                questionData[currentQuestionIndex]?.questionCode ===
                  'VQ005' && (
                  <>
                    <ChatQuestion
                      question={
                        questionData[currentQuestionIndex]?.questionValue
                      }
                    />
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      height={200}
                      alignItems={'center'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                    >
                      <PropertyWorthChat
                        handleInputChange={handleInputChange}
                        value={
                          questionData[currentQuestionIndex]?.questionAnswer !=
                          ''
                            ? questionData[currentQuestionIndex]?.questionAnswer
                            : priceRange
                        }
                      />
                    </Stack>
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'right'}
                      width={{ xs: '90%', sm: '45%', md: '45%' }}
                      position={'absolute'}
                      bottom={'20%'}
                    >
                      {currentQuestionIndex != 0 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        disabled={
                          !(
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== null &&
                            questionData[currentQuestionIndex]
                              ?.questionAnswer !== ''
                          )
                        }
                        onClick={handleNext}
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                      >
                        Next
                      </Button>
                    </Stack>
                  </>
                )}
            </>
            {finalTrigger && (
              <>
                <Box>
                  <Typography
                    style={{
                      color: 'rgb(154, 188, 102)',
                      textAlign: 'center',
                      fontFamily: 'poppins',
                      fontSize: matchessm ? '16px' : '24px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    Your feedback takes us one step nearer to the right sale!{' '}
                  </Typography>
                </Box>

                <img
                  src={successgif}
                  alt="successgif"
                  style={{
                    width: matchessm ? '100%' : '700px',
                  }}
                />
              </>
            )}

            {loading && (
              <ChatLoading value={'VE'} agentProfileImage={Loading} />
            )}
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'absolute',
            bottom: '0px',
          }}
        >
          <Box
            sx={{ padding: '20px', marginBottom: '10px', cursor: 'pointer' }}
            onClick={() => {
              localStorage.setItem('issurveyskipped', true);
              history.replace(previousRoute);
            }}
          >
            {!finalTrigger && (
              <Typography
                component={'div'}
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: '500',
                  fontSize: matchessm ? '12px' : '20px',
                  color: '#C4C4C4',
                }}
              >
                Skip Survey
              </Typography>
            )}
          </Box>
        </DialogActions>
      </Box>
    </>
  );
};

export default VendorChat;
